<template>
  <v-list v-bind="$attrs">
    <!-- severity -->
    <v-list-item v-if="note.hasOwnProperty('severity')">
      <v-list-item-action>
        <note-severity-icon :severity="note.severity" show-tooltip small />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t('fresh-vue-notes.fields.severity') }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ $t(`fresh-vue-notes.severity.${note.severity}`) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- title -->
    <v-list-item v-if="note.hasOwnProperty('title')">
      <v-list-item-action>
        <v-icon small>$freshvuenotes-title</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t('fresh-vue-notes.fields.title') }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ note.title ?? '-' }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- description -->
    <v-list-item v-if="note.hasOwnProperty('description')">
      <v-list-item-action>
        <v-icon small>$freshvuenotes-description</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t('fresh-vue-notes.fields.description') }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <long-text :text="note.description" />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- private -->
    <v-list-item v-if="note.hasOwnProperty('private')">
      <v-list-item-action>
        <notes-list-note-visibility :note="note" small force-show />
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t('fresh-vue-notes.fields.visibility') }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <span v-if="note.private">
            {{ $t('fresh-vue-notes.visibility.private') }}
          </span>
          <span v-else>
            {{ $t('fresh-vue-notes.visibility.public') }}
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { LongText } from '@freshsolutions/fresh-vue'
import NotesListNoteVisibility from './NotesListNoteVisibility'
import NoteSeverityIcon from './NoteSeverityIcon'

export default {
  name: 'NoteDetails',

  components: {
    LongText,
    NotesListNoteVisibility,
    NoteSeverityIcon
  },

  props: {
    note: {
      type: Object,
      required: true
    }
  }
}
</script>
